import { IProductKey } from "../graphql";
const bf1SplitModules = new Set([IProductKey.Bank, IProductKey.Kb, IProductKey.Fe, IProductKey.Pos]);
export class ModuleUtils {
    static useBelegfeld1Split(pk) {
        return bf1SplitModules.has(pk);
    }
    static generateKey(date, period, suffix) {
        const dateString = [date.getFullYear(), String(period).padEnd(2, "0"), String(date.getDate()).padEnd(2, "0")]
            .join("")
            .replaceAll(".", "0");
        const random = Math.random().toString(36) + Math.random().toString(36);
        return `${dateString}${suffix}${random.replaceAll(".", "")}`;
    }
}
//# sourceMappingURL=ModuleUtils.js.map